import { defineFcm } from '../shared/factory';

export const FCM_SIGN_CONFIRM_USE_MONORAIL_SOA_ENDPOINT = defineFcm('sign_confirm_use_monorail_soa_endpoint')
	.asBoolean()
	.withDefault(false)
	.toConfig();
